import React from 'react'
import WhiteOpciones from '../../../../media/felsv/WhiteOpciones.svg'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionComprobanteRetencionEmision} from '../../../../actions/action-creators'
import {useHistory} from 'react-router'
import { docsDatosReceptorReset } from '../../../../actions/documentos/documentos.actions'

const CREFooterFinalizacion = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionComprobanteRetencionEmision, dispatch)

  const nuevaFactura = () => {
    dispatch(actionsFE.comprobanteRetencionClearAll())
    dispatch(docsDatosReceptorReset())
    history.push('/otros-documentos/comprobante-retencion/formulario')
  }

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div className='card'>
        <div className='w-layout-vflex card-content'>
          <div className='w-layout-hflex button-actions'>
            <div style={{width: '15%'}}></div><div style={{width: '55%'}}></div>
            <button className='m button botton-footer' onClick={actionsFE.comprobanteRetencionOpenMasOpciones} >
              <img src={WhiteOpciones} loading='lazy' alt='Opciones' />
              <div>Más opciones</div>
            </button>
            <button className='m button botton-footer' onClick={nuevaFactura}><div>Nuevo Comprobante</div></button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CREFooterFinalizacion
